import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { Environment } from '@x/common/environment';
import { BrowserConsoleTransport, Log, LogLevel } from '@x/common/log';
import { AppComponent } from '@x/ecommerce-shop/app/app.component';
import { appConfig } from '@x/ecommerce-shop/app/app.config';
import { ENV_JSON } from '@x/ecommerce-shop/environment/environment.url';
import { getShopConfig } from '@x/ecommerce-shop/flavours/babylonstoren/config/shop.config';

Log.configure({
  level: LogLevel.TRACE,
  namespace: 'EcommerceShop',
  transport: new BrowserConsoleTransport(),
});

async function bootstrap() {
  await Environment.initBrowser(ENV_JSON);

  if (!Environment.requireBool('NG_PRODUCTION')) {
    loadDevMessages();
    loadErrorMessages();
  }

  if (Environment.requireBool('NG_PRODUCTION')) {
    enableProdMode();
  }

  return bootstrapApplication(AppComponent, appConfig(getShopConfig(Environment))).catch(
    onBootstrapError,
  );
}

function onBootstrapError(e: any) {
  Log.error('Application bootstrap error', e);
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', () => bootstrap());
}
